/* @flow */

import { XhrResponseType } from '../../../../helpers/jsHelpers/xhr';
import {
  BO_API_ADD_FAVORITE,
  BO_API_CREATE_STREAM2,
  BO_API_DELETE_FAVORITE,
  BO_API_FAVORITE_LIST,
  BO_API_GET_STREAMS,
  BO_API_PERSONAL_DATA,
  BO_API_PURCHASE,
  BO_API_PURCHASE_LIST,
  BO_API_PURCHASE_STATUS,
  BO_API_START_STREAM,
  BO_API_STOP_STREAM,
} from '../../../../redux/netgemApi/actions/videofutur/types/common';
import { type CommonPromisedXMLHttpRequestReturnType, commonNetworkErrorCallBack, commonPromisedXMLHttpRequest } from '../../helpers/CommonPromisedXMLHttpRequest';
import { HttpMethod } from '../../v8/types/HttpMethod';
import { buildUrl } from './bo';

const convertJson: (jsonResponse: any) => any = (jsonResponse) => {
  const {
    body: { createStream, favorites, getStreams, personalData, purchase, purchases, purchaseStatus, startStream, stopStream },
  } = jsonResponse;

  return {
    settings: [
      {
        type: BO_API_PERSONAL_DATA,
        url: personalData['_links'].personalData.href,
      },
      {
        type: BO_API_PURCHASE,
        url: purchase['_links'].purchase.href,
      },
      {
        type: BO_API_PURCHASE_STATUS,
        url: purchaseStatus['_links'].purchaseStatus.href,
      },
      {
        type: BO_API_PURCHASE_LIST,
        url: purchases['_links'].purchases.href,
      },
      {
        type: BO_API_ADD_FAVORITE,
        url: favorites['_links'].addFavorites.href,
      },
      {
        type: BO_API_DELETE_FAVORITE,
        url: favorites['_links'].deleteFavorites.href,
      },
      {
        type: BO_API_FAVORITE_LIST,
        url: favorites['_links'].favorites.href,
      },
      {
        type: BO_API_CREATE_STREAM2,
        url: createStream['_links'].createStream.href,
      },
      {
        type: BO_API_START_STREAM,
        url: startStream['_links'].startStream.href,
      },
      {
        type: BO_API_STOP_STREAM,
        url: stopStream['_links'].stopStream.href,
      },
      {
        type: BO_API_GET_STREAMS,
        url: getStreams['_links'].getStreams.href,
      },
    ],
  };
};

const discoveryRequest: (discoveryUrl: string, device: string, distributor: string, signal?: AbortSignal) => Promise<any> = (discoveryUrl, device, distributor, signal) => {
  const returnDiscoveryObject: CommonPromisedXMLHttpRequestReturnType = commonPromisedXMLHttpRequest(
    buildUrl(discoveryUrl, {
      device,
      distributor,
    }),
    HttpMethod.GET,
    XhrResponseType.Json,
    null,
    null,
    null,
    false,
    commonNetworkErrorCallBack,
    signal,
  );

  return returnDiscoveryObject.promise.then((response: any) => convertJson(response));
};

export default discoveryRequest;
